/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountStatus {
  ACTIVE = "ACTIVE",
  DORMANT = "DORMANT",
  ENROLMENT_ERROR = "ENROLMENT_ERROR",
  ENROLMENT_REJECTED = "ENROLMENT_REJECTED",
  INCOMPLETE = "INCOMPLETE",
  PENDING = "PENDING",
  VOID = "VOID",
  WITHDRAWN = "WITHDRAWN",
}

/**
 * An enumeration.
 */
export enum AccountTypeChoices {
  BUSINESS = "BUSINESS",
  BUSINESS_OCCUPIER = "BUSINESS_OCCUPIER",
  BUSINESS_VACANT = "BUSINESS_VACANT",
  DOMESTIC = "DOMESTIC",
  MANAGED = "MANAGED",
  OCCUPIER = "OCCUPIER",
  PORTFOLIO_LEAD = "PORTFOLIO_LEAD",
  VACANT = "VACANT",
}

/**
 * The method the account has specified they prefer we contact them
 */
export enum CommsDeliveryPreference {
  EMAIL = "EMAIL",
  POSTAL_MAIL = "POSTAL_MAIL",
}

export interface UpdateAddressInput {
  lines?: (string | null)[] | null;
  postcode?: string | null;
  countryCode?: string | null;
  deliveryPointIdentifier?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
